/**
 * canHandle3D — device-capability probe.
 *
 * WebGL2 + getContext('webgl2') success + reasonable resolution =
 * 3D-capable. Cached per browser-session so the probe runs once.
 */
let cached = null;
export function canHandle3D() {
    if (cached !== null)
        return cached;
    if (typeof document === 'undefined')
        return false;
    try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl2');
        cached = !!gl;
    }
    catch {
        cached = false;
    }
    return cached;
}
//# sourceMappingURL=canHandle3D.js.map